import IntercomHandler from './IntercomHandler';

export default IntercomHandler;
